/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Chip_Seller_ProfileInputs */

const tr_landing_community_chip_seller_profile = /** @type {(inputs: Landing_Community_Chip_Seller_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satıcı profili`)
};

const en_landing_community_chip_seller_profile = /** @type {(inputs: Landing_Community_Chip_Seller_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller profile`)
};

const de_landing_community_chip_seller_profile = /** @type {(inputs: Landing_Community_Chip_Seller_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäuferprofil`)
};

const ru_landing_community_chip_seller_profile = /** @type {(inputs: Landing_Community_Chip_Seller_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профиль продавца`)
};

/**
* | output |
* | --- |
* | "Seller profile" |
*
* @param {Landing_Community_Chip_Seller_ProfileInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_chip_seller_profile = /** @type {((inputs?: Landing_Community_Chip_Seller_ProfileInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Chip_Seller_ProfileInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_chip_seller_profile(inputs)
	if (locale === "de") return de_landing_community_chip_seller_profile(inputs)
	if (locale === "ru") return ru_landing_community_chip_seller_profile(inputs)
	return tr_landing_community_chip_seller_profile(inputs)
});